import { lazy, useState, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';

// project imports
import { EMPLOYER_ROLE, EMPLOYEE_ROLE, CS_TECHNICAL_ROLE, CS_OTHERS_ROLE, CA_USER } from 'config';
import useAuth from 'hooks/useAuth';

// routes
import LoginRoutes from './LoginRoutes';
import NoAuthRoutes from './NoAuthRoutes';
import EmployeeRoutes from './EmployeeRoutes';
import EmployerRoutes from './EmployerRoutes';
import Loadable from 'jsx/components/utilities/Loadable';
import AdminRoutes from './AdminRoutes';
import CsTechnicalRoutes from './CsTechnicalRoutes';
import CsOthersRoutes from './CsOthersRoutes';
import CaRoutes from './CaRoutes';


const PagesLanding = Loadable(lazy(() => import('jsx/pages/landing')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {

    const { isLoggedIn, user } = useAuth();
    const [allRoutes, setAllRoutes] = useState([]);

    useEffect(() => {
        const routes = [
            { path: '/', element: <PagesLanding /> },
            NoAuthRoutes,
            LoginRoutes,
        ];

        if (isLoggedIn) {
            if (user.role === EMPLOYER_ROLE) {
                routes.push(EmployerRoutes);
            } else if (user.role === EMPLOYEE_ROLE) {
                routes.push(EmployeeRoutes);
            } else if (user.role === CS_TECHNICAL_ROLE) {
                routes.push(CsTechnicalRoutes);
            } else if (user.role === CS_OTHERS_ROLE) {
                routes.push(CsOthersRoutes);
            } else if (user.role === CA_USER) {
                routes.push(CaRoutes, EmployerRoutes);
            } else {
                routes.push(AdminRoutes, EmployerRoutes);
            }
        }
        setAllRoutes(routes);
    }, [isLoggedIn, user]);

    return useRoutes(allRoutes);
}
